import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

export default function Footer({ t }) {
  return (
    <footer className="site-footer text-light pt-5">
      <div className="container py-5">
        <div className="row gy-4">
          {/* العمود الأول */}
          <div className="col-md-4">
            <h5 className="fw-bold mb-3">{t("companyName")}</h5>
            <p className="text-secondary">{t("companyDesc")}</p>
          </div>

          {/* العمود الثاني */}
          <div className="col-md-4">
            <h6 className="fw-bold mb-3">{t("quickLinks")}</h6>
            <ul className="list-unstyled text-secondary">
              <li className="mb-2">
                <Link className="text-decoration-none text-light" to="/services">
                  {t("services")}
                </Link>
              </li>
              <li className="mb-2">
                <Link className="text-decoration-none text-light" to="/about">
                  {t("about")}
                </Link>
              </li>
              <li>
                <Link className="text-decoration-none text-light" to="/contact">
                  {t("contact")}
                </Link>
              </li>
            </ul>
          </div>

          {/* العمود الثالث */}
          <div className="col-md-4">
            <h6 className="fw-bold mb-3">{t("getInTouch")}</h6>
            <p className="text-secondary mb-1">
              <i className="fas fa-map-marker-alt me-2"></i> {t("contact.address")}
            </p>
            <p className="text-secondary mb-1">
              <i className="fas fa-phone me-2"></i> {t("contact.mobile")}
            </p>
            <p className="text-secondary">
              <i className="fas fa-envelope me-2"></i> {t("contact.mail")}
            </p>
          </div>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="container d-flex flex-wrap align-items-center justify-content-between gap-2 py-3">
          <small>© {new Date().getFullYear()} {t("companyName")} — {t("rights")}</small>
          <small className="site-footer__credit">
            {t("footer.by")} <a href="https://keenguild.com/" target="_blank" rel="noopener noreferrer">KeenGuild <span aria-hidden="true">↗</span></a>
          </small>
        </div>
      </div>
    </footer>
  );
}
